/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useContext, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { AiOutlineRight } from "react-icons/ai";
import { useLocation } from "react-router-dom";

import useWindowSize from "../../hooks/useWindowSize";
import { CustomAdsFilters } from "../Context/AdsFilters";
import { CustomRequestsFilters } from "../Context/RequestsFilters";
import { getAdsByFilter } from "../../api/ads.api";
import { getRequestsByFilter } from "../../api/requests.api";

import "./SubHeader.scss";
import { useDebounce } from "../../hooks/useDebouce";

const DEPARTAMENTOS = [
  { id: "Costa", label: "Costa" },
  {
    id: "Campos Rústicos & Activos Singulares",
    label: "C.Rústicos & A.Singulares",
  },
  { id: "Patrimonio", label: "Patrimonio" },
  { id: "Residencial", label: "Residencial" },
  { id: "Todos", label: "Todos" },
];

const SubHeader = ({
  title,
  titleBreadcrumb,
  underTitle,
  list,
  location,
  setter,
  setTotalPages,
  setTotalElements,
}) => {
  const size = useWindowSize();
  const currentLocation = useLocation();
  const path = currentLocation.pathname; // Definimos path para evitar errores de undefined

  // 1. Contextos
  const isAds = title === "Anuncios";
  const adsCtx = useContext(CustomAdsFilters);
  const reqCtx = useContext(CustomRequestsFilters);

  const currentFilters = isAds ? adsCtx.adsFilters : reqCtx.requestsFilters;
  const filterSetter = isAds
    ? adsCtx.storeAdsFilters
    : reqCtx.storeRequestsFilters;

  // 2. Estado del Input y Debounce
  const [inputValue, setInputValue] = useState(currentFilters?.search || "");
  const debouncedSearch = useDebounce(inputValue, 500);

  // 3. Lógica de Filtrado Local (Consultores / Contactos)
  const handleLocalFilter = (text) => {
    if (!setter || !list) return;

    const cleanText = text
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
    const fields =
      title === "Consultores"
        ? ["fullName", "consultantEmail"]
        : ["fullName", "email", "company", "contactMobileNumber"];

    const filtered = list.filter((item) =>
      fields.some((field) =>
        String(item[field] || "")
          .toLowerCase()
          .includes(cleanText),
      ),
    );
    setter(filtered);
  };

  // 4. Lógica de API
  const handleRemoteFilter = async (search, department) => {
    if (!setter) return;

    const fetchMethod = isAds ? getAdsByFilter : getRequestsByFilter;
    const dataKey = isAds ? "ads" : "requests";

    const params = { ...currentFilters, search, department, page: 1 };
    const response = await fetchMethod(params);

    if (response) {
      setter(response[dataKey]);
      setTotalPages?.(response.pageInfo.totalPages);
      setTotalElements?.(response.pageInfo.totalElements);
    }
  };

  // 5. Efecto de búsqueda
  useEffect(() => {
    const isRemote = isAds || title === "Peticiones";

    if (isRemote) {
      if (debouncedSearch.length >= 3 || debouncedSearch.length === 0) {
        filterSetter({ ...currentFilters, search: debouncedSearch });
        handleRemoteFilter(debouncedSearch, currentFilters.department);
      }
    } else if (title === "Consultores" || title === "Contactos") {
      handleLocalFilter(debouncedSearch);
    }
  }, [debouncedSearch, currentFilters.department, title]);

  // Sincronizar input si el contexto cambia (ej. reset de filtros)
  useEffect(() => {
    setInputValue(currentFilters?.search || "");
  }, [currentFilters?.search]);

  const onSearchChange = (e) => setInputValue(e.target.value);
  const onDeptChange = (deptId) =>
    filterSetter({ ...currentFilters, department: deptId });

  return (
    <div className="subHeader">
      <div className="subHeader__title noDisplay">
        <h2>{title}</h2>
        {titleBreadcrumb && (
          <p>
            <AiOutlineRight fontSize="0.9em" style={{ marginRight: 10 }} />{" "}
            {titleBreadcrumb}
          </p>
        )}
      </div>

      <div className="subHeader__subtitle">
        {underTitle ? (
          <div className="subHeader__subtitle-item">
            <span>{underTitle}</span>
          </div>
        ) : (
          <>
            <div className="subHeader__subtitle-item noDisplay">
              <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                {["/consultores", "/contactos"].includes(path)
                  ? `${list?.length || 0} elementos`
                  : `${list || 0} elementos`}
                {/* {size > 1141 && " · Ordenado por fecha de última modificación"} */}
              </span>
            </div>

            <div
              className={
                size > 425 ? "subHeader__actions-row" : "subHeader__actions-col"
              }
            >
              {path.includes("anuncios") && !path.includes("anuncios/") && (
                <div className="subHeader__filter-box">
                  {DEPARTAMENTOS.map((dep) => {
                    const isActive = currentFilters.department === dep.id;
                    const baseClass = "subHeader__filter-box--item";
                    const borderClass = dep.specialBorder
                      ? `${baseClass}__border`
                      : baseClass;
                    const finalClass = isActive
                      ? `${borderClass}__active`
                      : borderClass;

                    return (
                      <button
                        key={dep.id}
                        className={finalClass}
                        onClick={() => onDeptChange(dep.id)}
                      >
                        <p>{dep.label}</p>
                      </button>
                    );
                  })}
                </div>
              )}

              <div className="subHeader__search-group">
                <div className="subHeader__subtitle_searchBarContainer">
                  <i className="pi pi-search" />
                  <InputText
                    value={inputValue}
                    onChange={onSearchChange}
                    placeholder="Buscar en esta lista un elemento"
                    className="subHeader__input-search"
                    style={
                      size > 425
                        ? { width: "30rem", marginRight: "1vw" }
                        : { width: "20rem" }
                    }
                  />
                </div>

                {!path.includes(`${title.toLowerCase()}/`) && (
                  <button
                    type="button"
                    className="subHeader__btn"
                    onClick={location}
                  >
                    Nuevo
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SubHeader;
